import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { State } from '../../../util/interactiveState.js';
import { selectToken } from '../../../util/tokenSelector.js';

var inputInteractiveState = function inputInteractiveState(theme, controlStyled, overlayStyled) {
  var primaryColor = selectToken(theme.background, 'product.primary');
  if (!primaryColor) return null;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    WebkitTapHighlightColor: 'transparent',
    userSelect: 'none'
  }, "& input ~ ".concat(controlStyled), {
    transition: 'background-color 0.2s ease-in-out, border-color .2s ease-in-out'
  }), "& input".concat(State.Hover, " ~ ").concat(controlStyled), {
    borderColor: primaryColor
  }), "& input".concat(State.Hover, " ~ ").concat(overlayStyled), {
    opacity: 0.08
  }), "@supports not selector(".concat(State.FocusedVisible, ")"), _defineProperty(_defineProperty(_defineProperty({}, "& input".concat(State.Focused, " ~ ").concat(controlStyled), {
    outline: 'none',
    opacity: 0.5,
    borderColor: primaryColor
  }), "& input:checked".concat(State.Focused, " ~ ").concat(controlStyled, ", & input:indeterminate").concat(State.Focused, " ~ ").concat(controlStyled), {
    outline: 'none',
    borderColor: primaryColor
  }), "& input".concat(State.Focused, " ~ ").concat(overlayStyled), {
    opacity: 0.12
  })), "& input".concat(State.FocusedVisible, " ~ ").concat(controlStyled), {
    outline: 'none',
    borderColor: primaryColor
  }), "& input:checked".concat(State.FocusedVisible, " ~ ").concat(controlStyled, ", & input:indeterminate").concat(State.FocusedVisible, " ~ ").concat(controlStyled, " "), {
    outline: 'none',
    borderColor: primaryColor
  }), "& input".concat(State.FocusedVisible, " ~ ").concat(overlayStyled), {
    opacity: 0.12
  }), "& input".concat(State.Pressed, " ~ ").concat(controlStyled), {
    borderColor: primaryColor
  }), "& input:checked".concat(State.Pressed, " ~ ").concat(controlStyled, ", & input:indeterminate").concat(State.Pressed, " ~ ").concat(controlStyled), {
    borderColor: primaryColor
  }), "& input".concat(State.Pressed, " ~ ").concat(overlayStyled), {
    opacity: 0.16
  });
};

export { inputInteractiveState as default };
//# sourceMappingURL=inputInteractiveState.js.map
